(function () {
  /* Carrito (drawer y pagina): bolsa de regalo por producto, codigo de descuento, subtotal, IR A CHECKOUT */
  var vbMsg = '', vbBusy = false, cartData = null;
  var GIFT = '<svg class="vb-ig__i" viewBox="0 0 212 233" aria-hidden="true" fill="#63C6BD"><path d="M60 61V32a26 26 0 0 1 26-26h40a26 26 0 0 1 26 26v29" fill="none" stroke="#63C6BD" stroke-width="12"/><rect y="61" width="212" height="37"/><rect y="129" width="212" height="37"/><rect y="197" width="212" height="36"/></svg>';
  function cartPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { cartData = c; return c; });
  }
  function isPage() { return !!document.getElementById('main-cart-items'); }
  function refresh() {
    if (isPage()) { location.reload(); return Promise.resolve(); }
    return fetch('/?sections=cart-drawer', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (s) {
      var n = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html').querySelector('.drawer__inner');
      var t = document.querySelector('#CartDrawer .drawer__inner');
      if (n && t) t.innerHTML = n.innerHTML;
    });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function discountBox() {
    var cx = document.createElement('div');
    cx.className = 'vb-cx';
    cx.innerHTML = '<form class="vb-dc" novalidate><input type="text" class="vb-dc__in" placeholder="Ingresa tu código" autocomplete="off" autocapitalize="characters"><button type="submit" class="vb-dc__btn">APLICAR</button></form>' +
      '<div class="vb-dc__tags"></div><p class="vb-dc__msg"></p>';
    if (vbMsg) { cx.querySelector('.vb-dc__msg').textContent = vbMsg; vbMsg = ''; }
    return cx;
  }
  var FREE = 35, promoOpen = null;
  function num(t) { var m = String(t || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : NaN; }
  /* Resumen del pedido estilo Urban Outfitters */
  function buildSum() {
    var w = document.createElement('div');
    w.className = 'vb-sum';
    w.innerHTML = '<h2 class="vb-sum__title">Resumen del pedido</h2><div class="vb-sum__box">' +
      '<div class="vb-sum__row"><span>SUBTOTAL</span><span class="vb-sum__amt"></span></div>' +
      '<div class="vb-sum__bs"></div><div class="vb-sum__rate"></div>' +
      '<div class="vb-fsb"><p class="vb-fsb__txt"></p><div class="vb-fsb__track"><span></span></div></div>' +
      '<p class="vb-sum__note">Opciones de pago y de envío en la siguiente página</p>' +
      '<div class="vb-sum__ctas"></div>' +
      '<div class="vb-promo"><button type="button" class="vb-promo__h"><span>Código de Descuento</span><i aria-hidden="true"></i></button><div class="vb-promo__b"></div></div>' +
      '</div>';
    var cx = discountBox();
    w.querySelector('.vb-promo__b').appendChild(cx);
    var open = promoOpen === null ? window.matchMedia('(min-width: 750px)').matches : promoOpen;
    if (cx.querySelector('.vb-dc__msg').textContent) open = true;
    w.querySelector('.vb-promo').classList.toggle('is-open', open);
    return w;
  }
  function paintSum(w, totalTxt, bsEl) {
    totalTxt = String(totalTxt || '').replace(/\s+/g, ' ').trim();
    var tNum = num(totalTxt);
    if (!isNaN(tNum)) totalTxt = 'Ref. ' + tNum.toFixed(2).replace('.', ',');
    var bsRaw = bsEl ? (bsEl.getAttribute('data-t') || bsEl.textContent) : '';
    var parts = bsRaw.split('·');
    var sig = totalTxt + '|' + bsRaw;
    if (w.dataset.sig === sig) return;
    w.dataset.sig = sig;
    w.querySelector('.vb-sum__amt').textContent = totalTxt;
    w.querySelector('.vb-sum__bs').textContent = (parts[0] || '').trim();
    w.querySelector('.vb-sum__rate').textContent = (parts[1] || '').trim();
    var t = tNum, left = FREE - t, pct = isNaN(t) ? 0 : Math.min(100, Math.max(0, t / FREE * 100));
    var fsb = w.querySelector('.vb-fsb');
    fsb.classList.toggle('is-free', !isNaN(t) && left <= 0);
    w.querySelector('.vb-fsb__txt').innerHTML = isNaN(t) ? '' : (left > 0 ? 'Te faltan <b>Ref. ' + left.toFixed(2).replace('.', ',') + '</b> para el <b>ENVÍO GRATIS</b>' : '✓ ¡Tienes <b>ENVÍO GRATIS</b>!');
    w.querySelector('.vb-fsb__track span').style.width = pct + '%';
  }
  function fill(cx, prefix) {
    getCart().then(function (c) {
      (c.items || []).forEach(function (it, i) {
        var row = document.getElementById(prefix + (i + 1));
        var det = row && row.querySelector('.cart-item__details');
        if (!det) return;
        det.querySelectorAll('.product-option').forEach(function (o) { if (/^\s*Bolsa de regalo/.test(o.textContent)) o.style.display = 'none'; });
        if (det.querySelector('.vb-ig')) return;
        var lb = document.createElement('label');
        lb.className = 'vb-ig';
        lb.innerHTML = GIFT + '<span>¿Es para regalo?</span><input type="checkbox" class="vb-ig__cb" data-line="' + (i + 1) + '"><span>SÍ</span>';
        lb.querySelector('input').checked = !!(it.properties && it.properties['Bolsa de regalo']);
        det.appendChild(lb);
      });
      if (!cx) return;
      if ((c.discount_codes || []).some(function (d) { return d.applicable; })) { var pr = cx.closest('.vb-promo'); if (pr) pr.classList.add('is-open'); }
      cx.querySelector('.vb-dc__tags').innerHTML = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) {
        var amt = (c.cart_level_discount_applications || []).filter(function (a) { return String(a.title).toUpperCase() === d.code.toUpperCase(); })[0];
        var txt = d.code + (amt ? ' (−Ref. ' + (amt.total_allocated_amount / 100).toFixed(2) + ')' : '') + ' aplicado';
        return '<span class="vb-dc__tag">✓ ' + esc(txt) + '<button type="button" data-code="' + esc(d.code) + '" aria-label="Quitar">&times;</button></span>';
      }).join('');
    });
  }
  function drawer() {
    var foot = document.querySelector('#CartDrawer .drawer__footer');
    var ft = foot && foot.querySelector('.cart-drawer__footer');
    var btn = document.getElementById('CartDrawer-Checkout');
    if (!foot || !ft || !btn) return;
    var w = foot.querySelector('.vb-sum');
    if (!w) {
      var money = btn.querySelector('.money');
      foot.dataset.vbTotal = money ? money.textContent.trim() : '';
      btn.textContent = 'IR A CHECKOUT';
      w = buildSum();
      ft.insertAdjacentElement('afterend', w);
      var ctas = foot.querySelector('.cart__ctas');
      if (ctas) w.querySelector('.vb-sum__ctas').appendChild(ctas);
      fill(w.querySelector('.vb-cx'), 'CartDrawer-Item-');
    }
    paintSum(w, foot.dataset.vbTotal || '', document.querySelector('#CartDrawer .vb-bs-cart'));
  }
  function page() {
    var foot = document.querySelector('#main-cart-footer .cart__blocks');
    var btn = document.getElementById('checkout');
    if (btn && btn.textContent.trim() !== 'IR A CHECKOUT') btn.textContent = 'IR A CHECKOUT';
    var rows = document.querySelector('#main-cart-items .cart-item');
    document.documentElement.classList.toggle('vb-cart2', !!rows);
    if (!foot) return;
    var w = foot.querySelector('.vb-sum');
    if (!w) {
      w = buildSum();
      foot.insertBefore(w, foot.firstChild);
      var ctas = foot.querySelector('.cart__ctas');
      if (ctas) w.querySelector('.vb-sum__ctas').appendChild(ctas);
      fill(w.querySelector('.vb-cx'), 'CartItem-');
    } else if (rows && !rows.querySelector('.vb-ig') && !vbBusy && !page._p) {
      page._p = 1; setTimeout(function () { page._p = 0; fill(null, 'CartItem-'); }, 50);
    }
    var st = document.querySelector('#main-cart-footer .totals__subtotal-value');
    paintSum(w, st ? st.textContent.trim() : '', document.querySelector('#main-cart-footer .vb-bs-cart'));
  }
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('.vb-ig__cb');
    if (!cb || vbBusy) return;
    vbBusy = true;
    var line = +cb.getAttribute('data-line'), on = cb.checked;
    getCart().then(function (c) {
      var it = c.items[line - 1];
      if (!it) return;
      var props = {};
      Object.keys(it.properties || {}).forEach(function (k) { if (k !== 'Bolsa de regalo') props[k] = it.properties[k]; });
      if (on) props['Bolsa de regalo'] = 'Sí';
      return cartPost('/cart/change.js', { line: line, quantity: it.quantity, properties: props });
    }).then(refresh).finally(function () { vbBusy = false; });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.vb-dc');
    if (!f) return;
    e.preventDefault();
    var code = f.querySelector('.vb-dc__in').value.trim().toUpperCase();
    if (!code || vbBusy) return;
    vbBusy = true;
    f.querySelector('.vb-dc__btn').textContent = '...';
    getCart().then(function (c0) {
      var codes = (c0.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }).concat([code]);
      return cartPost('/cart/update.js', { discount: codes.join(',') });
    }).then(function (c) {
      var d = (c.discount_codes || []).filter(function (x) { return x.code.toUpperCase() === code; })[0];
      if (d && d.applicable) { vbMsg = ''; return refresh(); }
      vbMsg = 'Este código no es válido o no aplica a tu pedido. Si es una Gift Card, la puedes usar en el siguiente paso (checkout).';
      var ok = (c.discount_codes || []).filter(function (x) { return x.applicable; }).map(function (x) { return x.code; });
      return cartPost('/cart/update.js', { discount: ok.join(',') }).then(function () {
        if (isPage()) { var m = f.parentNode.querySelector('.vb-dc__msg'); m.textContent = vbMsg; vbMsg = ''; f.querySelector('.vb-dc__btn').textContent = 'APLICAR'; return; }
        return refresh();
      });
    }).finally(function () { vbBusy = false; });
  }, true);
  document.addEventListener('click', function (e) {
    var ph = e.target.closest && e.target.closest('.vb-promo__h');
    if (ph) { var pr = ph.parentNode; pr.classList.toggle('is-open'); promoOpen = pr.classList.contains('is-open'); if (promoOpen) { var pi = pr.querySelector('.vb-dc__in'); if (pi) pi.focus(); } return; }
    var b = e.target.closest && e.target.closest('.vb-dc__tag button');
    if (b && !vbBusy) {
      vbBusy = true;
      var code = b.getAttribute('data-code');
      getCart().then(function (c) {
        var codes = (c.discount_codes || []).filter(function (d) { return d.applicable && d.code !== code; }).map(function (d) { return d.code; });
        return cartPost('/cart/update.js', { discount: codes.join(',') });
      }).then(refresh).finally(function () { vbBusy = false; });
      return;
    }
    /* El icono del carrito lleva a la pagina completa del carrito */
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    location.href = '/cart';
  }, true);
  /* Aviso de pocas unidades: ocultar si el numero es 0 o negativo */
  function stock() {
    document.querySelectorAll('.ProductForm__Inventory').forEach(function (p) {
      var m = p.textContent.match(/-?\d+/);
      var hide = !!(m && parseInt(m[0], 10) <= 0);
      if (p.classList.contains('vb-hide') !== hide) p.classList.toggle('vb-hide', hide);
    });
  }
  /* Pagina del carrito: actualizar cantidades al instante */
  var qT = null;
  function pageRender() {
    var itemsId = (document.getElementById('main-cart-items') || {}).dataset;
    var footId = (document.getElementById('main-cart-footer') || {}).dataset;
    if (!itemsId || !footId) { location.reload(); return Promise.resolve(); }
    var secs = [itemsId.id, footId.id, 'cart-icon-bubble'];
    return fetch('/cart?sections=' + secs.join(','), { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (s) {
      var c = getCart();
      [['#main-cart-items .js-contents', s[itemsId.id]], ['#main-cart-footer .js-contents', s[footId.id]]].forEach(function (p) {
        var t = document.querySelector(p[0]);
        var n = p[1] && new DOMParser().parseFromString(p[1], 'text/html').querySelector(p[0]);
        if (!n) { location.reload(); return; }
        if (t) t.innerHTML = n.innerHTML;
      });
      var b = document.getElementById('cart-icon-bubble');
      var nb = s['cart-icon-bubble'] && new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
      if (b && nb) b.innerHTML = nb.innerHTML;
      return c.then(function (cd) { if (!cd.item_count) location.reload(); });
    });
  }
  document.addEventListener('change', function (e) {
    var q = e.target.closest && e.target.closest('#main-cart-items .quantity__input');
    if (!q) return;
    e.stopImmediatePropagation();
    var line = +(q.dataset.index || (q.id.match(/\d+/) || [])[0]);
    var qty = Math.max(0, parseInt(q.value, 10) || 0);
    clearTimeout(qT);
    qT = setTimeout(function () {
      var row = q.closest('.cart-item');
      if (row) row.classList.add('vb-loading');
      cartPost('/cart/change.js', { line: line, quantity: qty }).then(pageRender).catch(function () { location.reload(); });
    }, 350);
  }, true);

  /* Formato del precio: "Ref. 18" en una sola linea */
  function fmtRef(n) { return 'Ref. ' + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n))); }
  function prices() {
    document.querySelectorAll('#main-cart-items .cart-item__totals .money, #main-cart-items .cart-item__details .money').forEach(function (m) {
      var n = num(m.textContent);
      if (isNaN(n)) return;
      var t = fmtRef(n);
      if (m.textContent !== t) m.textContent = t;
    });
    var l = document.querySelector('.template-cart .title-wrapper-with-link a');
    if (l && l.textContent.trim() !== 'SEGUIR COMPRANDO') { l.textContent = 'SEGUIR COMPRANDO'; l.setAttribute('href', '/collections/ver-todo'); }
  }

  /* En celular/tablet el carrusel va debajo del resumen del pedido; en computadora debajo de los productos */
  function placeXs(sec, items) {
    var wide = window.matchMedia('(min-width: 1100px)').matches;
    if (wide) { if (sec.previousElementSibling !== items) items.insertAdjacentElement('afterend', sec); sec.classList.remove('vb-xs--below'); return; }
    var fw = document.getElementById('main-cart-footer');
    var wrap = fw && fw.closest('.shopify-section');
    if (!wrap) return;
    var box = document.getElementById('vb-xs-below');
    if (!box) { box = document.createElement('div'); box.id = 'vb-xs-below'; box.className = 'page-width'; wrap.insertAdjacentElement('afterend', box); }
    if (sec.parentNode !== box) box.appendChild(sec);
    sec.classList.add('vb-xs--below');
  }
  /* "Te falto incluir algo?": los 10 productos disponibles de menor precio */
  var xsDone = false;
  function upsell() {
    if (xsDone) return;
    var items = document.getElementById('main-cart-items');
    if (!items || !items.querySelector('.cart-item')) return;
    xsDone = true;
    var pages = [1, 2, 3, 4];
    Promise.all([getCart()].concat(pages.map(function (p) {
      return fetch('/products.json?limit=250&page=' + p).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; });
    }))).then(function (res) {
      var inCart = {};
      (res[0].items || []).forEach(function (i) { inCart[i.product_id] = 1; });
      var all = [];
      res.slice(1).forEach(function (r) { all = all.concat(r.products || []); });
      var list = all.filter(function (p) {
        return !inCart[p.id] && !/gift ?card/i.test(p.product_type || '') && p.images && p.images.length && p.variants.some(function (v) { return v.available; });
      }).map(function (p) {
        var av = p.variants.filter(function (v) { return v.available; });
        var min = Math.min.apply(null, av.map(function (v) { return parseFloat(v.price); }));
        var v0 = av.filter(function (v) { return parseFloat(v.price) === min; })[0] || av[0];
        return { p: p, price: min, vid: v0.id, multi: av.length > 1 };
      }).filter(function (x) { return x.price > 0; }).sort(function (a, b) { return a.price - b.price; }).slice(0, 10);
      if (!list.length) return;
      var sec = document.createElement('div');
      sec.className = 'vb-xs';
      sec.innerHTML = '<div class="vb-xs__head"><h2 class="vb-xs__t">¿Te faltó incluir algo?</h2><div class="vb-xs__nav"><button type="button" class="vb-xs__btn" data-d="-1" aria-label="Anterior">&#8249;</button><button type="button" class="vb-xs__btn" data-d="1" aria-label="Siguiente">&#8250;</button></div></div>' +
        '<div class="vb-xs__track">' + list.map(function (x) {
          var img = x.p.images[0].src;
          img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          var url = '/products/' + esc(x.p.handle);
          return '<div class="vb-xs__card"><a class="vb-xs__link" href="' + url + '"><span class="vb-xs__img"><img src="' + esc(img) + '" alt="' + esc(x.p.title) + '" loading="lazy"></span>' +
            '<span class="vb-xs__name">' + esc(x.p.title) + '</span><span class="vb-xs__price">' + fmtRef(x.price) + '</span></a>' +
            (x.multi ? '<a class="vb-xs__add" href="' + url + '">VER OPCIONES</a>' : '<button type="button" class="vb-xs__add" data-v="' + x.vid + '">+ AGREGAR</button>') + '</div>';
        }).join('') + '</div>';
      items.insertAdjacentElement('afterend', sec);
      placeXs(sec, items);
      window.addEventListener('resize', function () { placeXs(sec, items); });
      sec.addEventListener('click', function (e) {
        var add = e.target.closest('button.vb-xs__add');
        if (add) {
          if (add.disabled) return;
          add.disabled = true;
          add.textContent = '...';
          cartPost('/cart/add.js', { items: [{ id: +add.dataset.v, quantity: 1 }] }).then(function (r) {
            if (r && r.status && r.status >= 400) throw r;
            add.textContent = '✓ AGREGADO';
            add.classList.add('is-done');
            return pageRender();
          }).then(function () {
            var card = add.closest('.vb-xs__card');
            setTimeout(function () { if (card) card.remove(); if (!sec.querySelector('.vb-xs__card')) sec.remove(); }, 1200);
          }).catch(function () { add.disabled = false; add.textContent = 'AGOTADO'; });
          return;
        }
        var b = e.target.closest('.vb-xs__btn');
        if (!b) return;
        var tr = sec.querySelector('.vb-xs__track');
        tr.scrollBy({ left: (+b.dataset.d) * tr.clientWidth * 0.9, behavior: 'smooth' });
      });
    });
  }

  function all() { drawer(); page(); stock(); prices(); upsell(); }
  all();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  new MutationObserver(all).observe(document.documentElement, { childList: true, subtree: true });
})();
